import { SelectProps } from 'antd';
import { useEffect, useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';

import useSelectOptions from '@/hooks/useSelectOptions';
import {
  WorkOrderTag,
  WorkOrderTagsQueryFilter,
} from '@/core/domain/workorder/WorkOrderTags/WorkOrdersTags.types';
import { useWorkOrdersTags } from '@/core/domain/workorder/WorkOrderTags/WorkOrdersTags.hooks';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: WorkOrderTagsQueryFilter;
  queryEnable?: boolean;
};

export default function TagsInfiniteSelectField({
  queryFilter,
  queryEnable = false,
  ...props
}: Props) {
  const [selectClicked, setSelectClicked] = useState<boolean>(queryEnable);
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  useEffect(() => {
    setSelectClicked(queryEnable);
  }, [queryEnable]);

  const tagList = useWorkOrdersTags(
    {
      ...queryFilter,
      rows: 10,
      search,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );

  const options = useSelectOptions<WorkOrderTag, WorkOrderTag>({
    list: tagList,
    selectProps: props,
    labelFormatter: (tag) => tag.name,
  });

  return (
    <InfiniteSelect
      fetchNextPage={tagList.fetchNextPage}
      hasNextPage={tagList.hasNextPage}
      loading={tagList.isFetching}
      options={options}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
}
